export interface ISearch {
    list?: Array<Object> | null;
}

export class Search {
    public list!: Array<Object> | null;

    constructor(list: Array<Object>) {
        this.list = list;
    }

    public static empty(): Search {
        return new Search(new Array<Object>());
    }
}
